import AgeGenderModal from 'shared/components/content_gating/age_gender_modal';
import { QRCodeSVG } from '@cheprasov/qrcode';
import { IsPremiumUser } from 'shared/vidio_helpers';
import Topic from 'shared/topic';
import KmklabsUtil from 'shared/kmklabs_util';
import AhoyEvent from 'shared/ahoy_event';
import { ActiveLanguage } from 'shared/vidio_helpers';
import Blocker from 'components/shared/Blocker';

export default class ContentGatingBanner {
  constructor(currentUser) {
    this.currentUser = currentUser;
  }

  init() {
    const appDownloadBanner = document.querySelector('.content-gating-banner.content-gating-banner--app-download.hide');
    const loginBannerContainer = document.querySelector('.content-gating-banner.content-gating-banner--login.hide');
    const ageGenderBanner = document.querySelector('.content-gating-banner.content-gating-banner--age-gender.hide');

    this._disposeCounter = 0;
    this._disposeIntervalId = null;

    if (appDownloadBanner && !IsPremiumUser.get()) {
      this.banner = 'app_download';
      if (window.player != undefined) {
        this.initBanner(appDownloadBanner)
      } else {
        Topic.subscribeOnce('player/ready', this.initBanner.bind(this, appDownloadBanner));
        Topic.subscribeOnce('player/player/loaded', this.initBanner.bind(this, appDownloadBanner));
      }
    } else if (loginBannerContainer && !this.currentUser) {
      this.banner = 'login_blocker';
      if (window.player != undefined) {
        this.initBanner(loginBannerContainer)
      } else {
        Topic.subscribeOnce('player/ready', this.initBanner.bind(this, loginBannerContainer));
        Topic.subscribeOnce('player/player/loaded', this.initBanner.bind(this, loginBannerContainer));
      }
    } else if (ageGenderBanner && this.ageGenderEmpty() && !IsPremiumUser.get()) {
      let ageGenderModal = this.createAgeGenderModal();
      ageGenderModal.init();
      if (window.player != undefined) {
        this.initBanner(ageGenderBanner);
      } else {
        Topic.subscribeOnce('player/ready', this.initBanner.bind(this, ageGenderBanner));
        Topic.subscribeOnce('player/player/loaded', this.initBanner.bind(this, ageGenderBanner));
      }
      this.banner = 'complete_profile';
    }
  }

  createAgeGenderModal(){
    let content = {
      type: this.type,
      id: KmklabsUtil.videoId()
    };
    return new AgeGenderModal(this.currentUser, content);
  }

  initBanner(banner){
    if (window.contentGatingActionRequiredAfter === undefined || window.contentGatingActionRequiredAfter === 0) {
      this.showBanner(banner);
    } else {
      const initBannerInterval = setInterval(() => {
        if (Object.keys(window.player.tech()).length != 0) {
          clearInterval(initBannerInterval);
          this.addEventTimeUpdate(banner);
        }
      }, 100);
    }
  }

  addEventTimeUpdate(banner) {
    window.player.tech().on(
      'timeupdate',
      this.showContentGatingIfPlayLimitExceeded.bind(this, banner)
    );
  }

  storeInitialPlayerTime() {
    if (!this.initialPlayerTime) {
      this.initialPlayerTime = window.player.tech().currentTime();
    }
  }

  showContentGatingIfPlayLimitExceeded(banner) {
    this.storeInitialPlayerTime();

    if (this.playTimeElapsed() >= window.contentGatingActionRequiredAfter) {
      this.showBanner(banner);
    }
  }

  playTimeElapsed() {
    return (window.player.tech().currentTime() - (this.initialPlayerTime || 0)); 
  }

  showBanner(banner) {
    const qrCode = banner.querySelector('.content-gating-banner__qr-image');
    if (qrCode) {
      this.generateQrCode(qrCode);
    }

    if(this.banner === 'app_download') {
      this.initAppDownloadBanner(banner);
    } 

    if(this.banner === 'login_blocker') {
      this.showLoginBanner(banner);
    } else {
      banner.classList.remove('hide');
    }

    Topic.publish('content_gating/banner/ready');
    this.sendBlockerEvent();
    this.disablePlayer();
  }

  showLoginBanner(loginBannerContainer) {
    let lang = ActiveLanguage.get();
    let {message: title, button: buttonText} =
      window.Locale[lang].content_gating_banner.login;
    let currentPage = new URL(window.location.href);
    currentPage.searchParams.set('t', window.contentGatingActionRequiredAfter);
    let returnLink = encodeURIComponent(currentPage.pathname+currentPage.search);
    let buttons = [{
      text: buttonText,
      link: `/users/login?user_return_to=${returnLink}&onboarding_source=login_blocker`,
      align: 'horizontal',
      theme: 'red'
    }]
    let loginBlocker = new Blocker({element: loginBannerContainer, title, buttons});
    loginBlocker.show();

    loginBannerContainer.classList.remove('hide');
  }

  ageGenderEmpty(){
    if(!this.currentUser) return true;
    return !(this.currentUser.user_gender_confirmed && this.currentUser.age)
  }

  generateQrCode(qrCode) {
    if(qrCode) {
      const deepLinkUrl = qrCode.getAttribute('data-deep-link');
      const centerLogoUrl = qrCode.getAttribute('data-logo');

      let imageOption = null;
      if (centerLogoUrl) {
        imageOption = {
          image: {
            source: centerLogoUrl,
            width: '20%',
            height: '20%',
            x: 'center',
            y: 'center',
          }
        };
      }

      const qrSVG = new QRCodeSVG(deepLinkUrl, imageOption);
      const xmlWithQRCode = qrSVG.toString();

      qrCode.innerHTML = xmlWithQRCode;
    }
  }

  initAppDownloadBanner(banner) {
    if(this.currentUser) {
      const loginSubtitle = banner.querySelector('.content-gating-banner__subtitle--login');
      if(loginSubtitle) {
        loginSubtitle.classList.remove('hide');
      }
    } else {
      const nonLoginSubtitle = banner.querySelector('.content-gating-banner__subtitle--non-login');
      if(nonLoginSubtitle) {
        nonLoginSubtitle.classList.remove('hide');
      }
    }
  }

  sendBlockerEvent() {
    AhoyEvent.send('PLAYBACK::BLOCKER', {
      content_type: this.type,
      is_premier: KmklabsUtil.isPremium(),
      content_id: KmklabsUtil.videoId(),
      blocker_type: this.banner,
    });
  }

  get type() {
    if(this._type == undefined) {
      let type = document.querySelector('body').getAttribute('data-controller').includes('videos');
      this._type = type ? 'vod' : 'livestreaming';
    }
    return this._type;
  }

  disablePlayer() {
    if(this._disposeIntervalId !== null) return;

    this._disposeIntervalId = setInterval(this.disposePlayer.bind(this), 100);
  }

  disposePlayer() {
    if(window.player && window.player.tech() && window.player.tech().plugin()) {
      window.player.tech().dispose();
      clearInterval(this._disposeIntervalId);
      this._disposeIntervalId = null;
    } else if(this._disposeCounter == 100) {
      clearInterval(this._disposeIntervalId);
      this._disposeIntervalId = null;
    }
    this._disposeCounter++;
  }
}
